import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown, Check } from 'lucide-react';
interface FilterDropdownProps {
  label?: string;
  value: string;
  options?: string[];
  onChange?: (value: string) => void;
  className?: string;
}
export function FilterDropdown({
  label,
  value,
  options = [],
  onChange,
  className = ''
}: FilterDropdownProps) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  // Close on click outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setIsOpen(false);
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen]);
  // Close on Escape
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsOpen(false);
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
    }
    return () => document.removeEventListener('keydown', handleEsc);
  }, [isOpen]);
  const handleSelect = (option: string) => {
    onChange?.(option);
    setIsOpen(false);
  };
  return <div className={`relative ${className}`} ref={dropdownRef} data-id="element-986">
      {label && <label className="block text-xs font-medium text-gray-500 dark:text-gray-400 mb-1" data-id="element-987">
          {label}
        </label>}
      <button type="button" onClick={() => setIsOpen(!isOpen)} className={`
          flex items-center justify-between w-full h-10 pl-3 pr-2.5 
          bg-white dark:bg-gray-800 
          border rounded-lg text-sm font-medium text-gray-900 dark:text-white 
          hover:border-gray-300 dark:hover:border-gray-600 
          transition-all cursor-pointer shadow-sm
          ${isOpen ? 'border-gray-900 dark:border-white ring-2 ring-gray-900/5 dark:ring-white/5' : 'border-gray-200 dark:border-gray-700'}
        `} data-id="element-988">
        <span className="truncate" data-id="element-989">{value}</span>
        <ChevronDown className={`w-4 h-4 text-gray-400 dark:text-gray-500 ml-2 shrink-0 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-990" />
      </button>

      {isOpen && <div className="absolute z-50 mt-1.5 w-full min-w-[160px] bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg shadow-black/10 dark:shadow-black/30 py-1 max-h-60 overflow-y-auto animate-in fade-in slide-in-from-top-1 duration-150" data-id="element-991">
          {options.map(option => {
        const isSelected = option === value;
        return <button key={option} type="button" onClick={() => handleSelect(option)} className={`
                  w-full flex items-center justify-between px-3 py-2 text-sm text-left transition-colors
                  ${isSelected ? 'bg-gray-100 dark:bg-gray-700 text-gray-900 dark:text-white font-semibold' : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700/50'}
                `} data-id="element-992">
                <span className="truncate" data-id="element-993">{option}</span>
                {isSelected && <Check className="w-4 h-4 text-gray-900 dark:text-white shrink-0 ml-2" data-id="element-994" />}
              </button>;
      })}
        </div>}
    </div>;
}